
import { defineComponent, ref } from "vue";
import AuthenticatorHeader from "./AuthenticatorHeader.vue";
import NavigationButton from "./NavigationButton.vue";
import { focusRequiredEmptyInput } from "@/util/auth-ui";
import { useGammaAuthenticator } from "@/composeable/gamma-authenticator";
import { AuthUIState } from "@/types/auth-ui";

export default defineComponent({
  components: { AuthenticatorHeader, NavigationButton },
  emits: ["signedIn"],
  setup() {
    const authenticator = useGammaAuthenticator();

    const email = ref("");
    const password = ref("");
    const errorMessage = ref<string | undefined>(undefined);
    const loading = ref(false);

    const emailRef = ref();
    const passwordRef = ref();

    async function signIn() {
      focusRequiredEmptyInput([emailRef.value.$el, passwordRef.value.$el]);
      if (!email.value.length || !password.value.length) return;

      loading.value = true;
      try {
        await authenticator.signIn(email.value, password.value);
      } catch (error) {
        switch (error.name) {
          case "PasswordResetRequiredException":
            authenticator.setUiState(AuthUIState.ResetPassword, {
              email: email.value,
              errorMessage:
                "The administrator of your organisation has requested a password reset",
            });
            break;
          case "NotAuthorizedException":
            errorMessage.value = "Incorrect email or password";
            break;
          default:
            errorMessage.value = error.message;
            break;
        }
        console.error(error);
      }
      loading.value = false;
    }

    return {
      email,
      password,
      emailRef,
      passwordRef,
      AuthUIState,
      errorMessage,
      loading,
      signIn,
    };
  },
});
